import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Contact from "../pages/contact/Contact";
import Work from "../pages/healthcare/work/Work";
import Vacancy from "../pages/healthcare/vacancy/Vacancy";
import Flex from "../pages/commissioners/flex/Flex";
import Crisis from "../pages/commissioners/crisis/Crisis";
import Planning from "../pages/commissioners/planning/Planning";
import NotFound from "../pages/notfound/NotFound";
import { useEffect } from "react";
import Search from "../pages/search/Search";
import VacancyDetails from "../pages/healthcare/vacancy/VacancyDetails";
import Apply from "../pages/apply/Apply";
import Privacy from "../pages/privacy/Privacy";
import Terms from "../pages/terms/Terms";
import Admin from "../pages/admin/Admin";

function AppRoutes() {
  const location = useLocation();

  // Scroll to top whenever location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const titles = {
      "/": "Smart-Personeel - Home",
      "/about": "Smart-Personeel - Over Smart",
      "/admin": "Smart-Personeel - Admin",
      "/contact": "Smart-Personeel - Contact",
      "/search": "Smart-Personeel - Zoekresultaten",
      "/apply": "Smart-Personeel - Direct aanmelden",
      "/privacy": "Smart-Personeel - Privacy",
      "/terms": "Smart-Personeel - Algemene Voorwaarden",
      "/healthcare/work": "Smart-Personeel - Direct aanmelden",
      "/healthcare/vacancy": "Smart-Personeel - Vacatures",
      "/commissioners/flex": "Smart-Personeel - Flex",
      "/commissioners/crisis": "Smart-Personeel - Crisis Team",
      "/commissioners/planning": "Smart-Personeel - Planning",
    };

    const path = location.pathname;
    if (path.startsWith("/healthcare/vacancy/")) {
      document.title = "Smart-Personeel - Vacature Details";
    } else {
      document.title = titles[path] || "Smart-Personeel - 404";
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/apply" element={<Apply />} />
      <Route path="/search" element={<Search />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/healthcare/work" element={<Work />} />
      <Route path="/healthcare/vacancy" element={<Vacancy />} />
      <Route
        path="/healthcare/vacancy/:vacancyId"
        element={<VacancyDetails />}
      />
      <Route path="/commissioners/flex" element={<Flex />} />
      <Route path="/commissioners/crisis" element={<Crisis />} />
      <Route path="/commissioners/planning" element={<Planning />} />
      <Route path="*" component={NotFound} element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
